<template>
  <section class="pagination" v-if="totalRecord/pageSize>1">
    <div class="ul">
      <div class="li">
        <img
          @click="prePage"
          src="/static/v2/pagination/pre_page_arrow_active.png"
          v-if="pageIndex>1"
        />
        <img src="/static/v2/pagination/pre_page_arrow.png" alt v-else />
      </div>
      <div class="li" v-for="(item,index) in totalPageList" :key="index" @click="changePage(index)">
        <span v-if="index === 0 && pageIndex!==1">{{index+1}}</span>
        <span v-if="showPreDotted && index === 1">...</span>
        <span
          v-if="pageIndex > index -3 && pageIndex<index+1 && index !== 0 && index !== totalPageList.length-1 "
        >{{index+1}}</span>
        <span class="actived" v-if="pageIndex === index+1">{{pageIndex}}</span>
        <span
          v-if="pageIndex >index+1  && pageIndex< index+4 && index !== totalPageList.length-1 && index!==0"
        >{{index+1}}</span>
        <span v-if="showNextDotted && index ===totalPageList.length-2">...</span>
        <span
          v-if="index ===totalPageList.length-1 && pageIndex !== totalPageList.length"
        >{{index+1}}</span>
      </div>
      <div class="li">
        <img
          @click="nextPage"
          src="/static/v2/pagination/next_page_arrow_active.png"
          v-if="pageIndex<totalPageList.length"
        />
        <img src="/static/v2/pagination/next_page_arrow.png" alt v-else />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: ["totalRecord", "pageSize", "pageIndex", "OnCurrentChanged"],
  data() {
    return {
      activedIndex: 0
    };
  },
  methods: {
    prePage() {
      if (this.pageIndex > 1) {
        this.activedIndex--;
        this.$emit("OnCurrentChanged", this.pageIndex - 1);
      }
    },
    nextPage() {
      if (this.pageIndex < this.totalPageList.length) {
        this.activedIndex++;
        this.$emit("OnCurrentChanged", this.pageIndex + 1);
      }
    },
    changePage(index) {
      if (this.pageIndex !== index + 1) {
        this.$emit("OnCurrentChanged", index + 1);
      }
    }
  },
  computed: {
    totalPageList() {
      const total = Math.round(Math.ceil(this.totalRecord / this.pageSize));
      return [...new Array(total || 0)];
    },
    showPreDotted() {
      return this.pageIndex > 4;
    },
    showNextDotted() {
      return this.pageIndex < this.totalPageList.length - 4;
    }
  }
};
</script>

<style lang="stylus" scoped>
.pagination {
  padding: 25px 0;

  div.ul {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    div.li {
      cursor: pointer;

      img {
        width: 10px;
        height: 16px;
        padding: 20px;
      }

      span {
        font-size: 15px;
        font-weight: 600;
        color: #333;
        display: inline-block;
        width: 30px;
        height: 30px;
        line-height: 30px;
        text-align: center;

        &.actived {
          color: #2026cc;
        }

        &:hover {
          background: #F5F5F5;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/v2/Pagination.vue